<template>
    <v-main class="polygon">
        <v-app-bar app color="toolbar" flat height=64 class="pa-0" style="border-bottom: 1px solid var(--v-secondary-lighten5) !important;">
            <router-link to="/" style="background-color: var(--v-toolbar-base) !important;">
                <v-toolbar-items class="mr-2">
                    <img height=36 src="~@/assets/images/header.svg">
                </v-toolbar-items>
            </router-link>
            <v-toolbar-title class="font-weight-medium">{{$t('title')}}</v-toolbar-title>
            <v-spacer />
        </v-app-bar>
        <alert-container></alert-container>
    </v-main>
</template>
<script>
import Vue from 'vue'
import FileSaver from 'file-saver'

export default {
  name: 'download-document',
  data () {
    return {
      loading: false,
      token: '',
      title: ''
    }
  },
  created () {
    this.token = this.$route.query.token
    this.$http.get(Vue.$apiConfig.projectDocumentRevisionSecurityGet.replace('{downloadToken}', this.token))
      .then(response => {
        this.logConsole(response)
        this.title = response.body.payload.title
        if (!response.body.payload.secureLink) {
          this.downloadPublicDocument()
        } else {
          this.downloadSecuredDocument(response.body.payload)
        }
      }, error => {
        this.logConsole(error)
        this.formatErrorResponse(error)
      })
  },
  methods: {
    downloadPublicDocument () {
      this.$http.get(Vue.$apiConfig.anonymousProjectDocumentGet.replace('{downloadToken}', this.token), { responseType: 'arraybuffer' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, this.title)
          },
          error => {
            this.formatErrorResponse(error)
          }
        )
    },
    downloadSecuredDocument (revision) {
      this.$router.push('/projects/' + revision.projectCode + '/documents/' + revision.documentId + '/revisions/' + revision.id + '?automaticDownload=true')
    }
  }
}
</script>
